import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AddressBookDto, EpimsBankDto, IndividualAcreagesDto, LessorInfoDto, LessorRepresentativeDto, LessorRepTypeDto } from '@cradua/data';
import Swal from 'sweetalert2';
import { LessorInfoListModalComponent } from './lessor-info-list-modal/lessor-info-list-modal.component';

@Component({
  selector: 'cradua-lessor-info-list',
  templateUrl: './lessor-info-list.component.html',
  styleUrls: ['./lessor-info-list.component.scss']
})
export class LessorInfoListComponent implements OnChanges {

  @Input() lessorInfos: LessorInfoDto[];
  @Input() individualAcreages: IndividualAcreagesDto[];
  @Input() lessorRepresentatives: LessorRepresentativeDto[];
  @Input() addressBooks: AddressBookDto[];
  @Input() lessorRepTypes: LessorRepTypeDto[];
  @Input() banks: EpimsBankDto[];
  @Output() emitLessorInfo = new EventEmitter<any>();
  @Output() emitLessorInfoDelete = new EventEmitter<any>();
  assignedArea = 0;

  transformedLessor: LessorInfoDto[];

  constructor(
    public dialog: MatDialog,
  ) { }

  ngOnChanges(): void {

    // this.transformedLessor = this.lessorInfos.map(item => {
    //    return {
    //      addressBook: {
    //        BankName: this.getBankName(this.getAddressBook(item.AddressBookId)['BankId']),
    //        ...this.getAddressBook(item.AddressBookId)
    //      },
    //      ...item
    //    }
    // });


  }

  getSurveyArea(addr: LessorInfoDto) {
    if(this.individualAcreages != null && this.individualAcreages.length) {
      const filteredIndividualAcreages = this.individualAcreages.filter(data => data.LessorsId === addr.id && data.AddressBookId === addr.AddressBookId);
      return filteredIndividualAcreages.length ?
      filteredIndividualAcreages.map((item) => item.NetArea)
      .reduce((prev, next) => prev + next) : 0;
    } else {
      return 0;
    }
  }

  getAddressBook(id: string) {
    const foundAddressBook = this.addressBooks.find(item => item.id === id);
    return foundAddressBook ? foundAddressBook : {};
  }

  // getBankName(id: string) {
  //   const found = this.banks.find(item => item.id === id);
  //   return found ? found.BankName : '';
  // }

  onView(value: LessorInfoDto) {
    this.emitLessorInfo.emit(value);
  }

  onDelete(value, index) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        // this.dispatchDelete.emit(id);
        const deleteLessorInfo = [];
        deleteLessorInfo.push(value.id);
        this.emitLessorInfoDelete.emit(deleteLessorInfo);
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  onRepresentative(lessor: LessorInfoDto) {
  const lessorRepresentative = this.lessorRepresentatives.filter(data => data.LessorsId === lessor.id);

  const transformedLessorRepresentative = lessorRepresentative.map(item => {
    return {
      LessorRepTypeName: this.getLessorRepTypeName(item.LessorRepTypeId),
      addressBook: {
        ...this.getAddressBook(item.AddressBookId)
      },
      ...item
    }
 });

 if(!transformedLessorRepresentative.length) {
   return;
 }

    const dialogConfig = new MatDialogConfig();

    // dialogConfig.disableClose = false;
    dialogConfig.id = "modal-component";
    dialogConfig.height = "80%";
    dialogConfig.width = "90%";
    // dialogConfig.minHeight = '100vh';
    // dialogConfig.minWidth = '100%'
    // dialogConfig.panelClass = "custom-dialog-container";
    // dialogConfig.backdropClass = "backdropBackground";

    dialogConfig.data = {
      transformedLessorRepresentative
    }

    const dialogRef = this.dialog.open(
      LessorInfoListModalComponent,
      dialogConfig,
    );

    dialogRef.afterClosed().subscribe((result: AddressBookDto) => {
      // console.log('result got ', result);
      if(result !== undefined) {
        // this.selectedAddressBook = result;
        // this.lessorTemForm.patchValue({AddressBookName: result.Name});
      }

    });
  }

  getLessorRepTypeName(id: string) {
    const found = this.lessorRepTypes.find(item => item.id === id);
    return found ? found.LessorRepName : '';
  }

}
